// Target adult height — TNO formula (Dutch population), see growth-spec §6.1.

import type { Sex } from './lms.ts';

export type TargetHeight = {
  /** Predicted adult height in cm. */
  th_cm: number;
  /** ±range for the 95% CI band, in cm. */
  range_cm: number;
};

export function tnoTargetHeight(
  sex: Sex,
  fatherCm: number,
  motherCm: number,
): TargetHeight {
  if (sex === 'M') {
    return {
      th_cm: 44.5 + 0.376 * fatherCm + 0.411 * motherCm,
      range_cm: 11,
    };
  }
  return {
    th_cm: 47.1 + 0.334 * fatherCm + 0.364 * motherCm,
    range_cm: 10,
  };
}
